<main class="page-layout">
  <app-sidemenu></app-sidemenu>
  <div id="page-wrapper" class="page-wrapper">
    <app-header></app-header>
    <div class="page-wrapper-content"><router-outlet></router-outlet></div>
  </div>
  <app-feedback-window *ngIf="isFeedbackOpen()"></app-feedback-window>
</main>
